import React from 'react';

const ComingSoon = () => {
    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-body text-center py-5">
                        <h2>Coming Soon</h2>
                        <p className="text-muted mt-3">Questa funzionalità sarà disponibile a breve.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComingSoon;
